import { Stage } from "views/settings-crm/types/stage";
import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { hexToRgba } from "shared/utils";

export const TimeLineStageLabel = ({ stage }: { stage?: Stage | string }) => {
  if (!stage) return null;

  const name = typeof stage === "string" ? stage : stage.name;
  const color = typeof stage === "string" ? undefined : stage.color;
  if (!name) return null;

  return (
    <Badge
      variant={BadgeVariant.BASE}
      size={BadgeSize.SM}
      style={color ? { backgroundColor: hexToRgba(color, 0.1) } : undefined}
    >
      <div className="flex items-center">
        <Show if={Boolean(color)}>
          <span
            className="rounded-full w-2 h-2 inline-block mr-2"
            style={{ backgroundColor: color }}
          />
        </Show>
        {name}
      </div>
    </Badge>
  );
};
